/*
 * @Description: 
 * @Author: henry
 * @Date: 2025-03-20 10:05:52
 * @LastEditors: henry
 * @LastEditTime: 2025-04-22 17:15:12
 */
export default {
  store: null,
  dispatch(...args) {
    const { page, noLoading } = args[1] || {}
    if ((!page || page < 2) && !noLoading) {
      this.loading?.()
    }
    return this.store?.dispatch(...args).then(data => {
      if(args[2]!==false){
        this.stopLoading?.()
      }
      return data
    })
  }
}
